import { useState } from "react";
import PopupWin from "../../../../../components/PopupWin";
import SequenceList from "../../../../Mapping/Reports/SequenceList";

const CreateTriggerModal = ({
  visible,
  onClose,
  onSave,
  editingTriggerId,
  initialData,
  showWarning,
}) => {
  const [triggerName, setTriggerName] = useState(initialData?.name || "Daniel");
  const [triggerStatus, setTriggerStatus] = useState(initialData?.status ?? true);
  const [triggerAutoTrigger, setTriggerAutoTrigger] = useState(initialData?.autoTrigger ?? true);
  const [triggerSequences, setTriggerSequences] = useState(
    initialData?.sequences || [
      [
        { field: 'stage', type: 'exact', value: 'Closed Won', key: 'seq1_filter1' },
        { field: 'hq_id', type: 'is_not', value: ['Israel', 'UK', 'USA', 'Russia'], key: 'seq1_filter2' }
      ],
      [
        { field: 'stage', type: 'exact', value: 'Closed Won', key: 'seq2_filter1' },
        { field: 'hq_id', type: 'is_not', value: 'Israel', key: 'seq2_filter2' },
        { field: 'example', type: 'exact', value: 'Another', key: 'seq2_filter3' }
      ]
    ]
  );

  const handleSave = () => {
    if (!triggerName.trim()) {
      if (showWarning) {
        showWarning("Please enter a trigger name");
      }
      return;
    }

    onSave({
      name: triggerName,
      status: triggerStatus,
      autoTrigger: triggerAutoTrigger,
      sequences: triggerSequences,
    }, editingTriggerId);

    onClose();
  };

  const handleAddSequence = () => {
    setTriggerSequences([...triggerSequences, []]);
  };

  const handleSequenceClear = (sequenceIndex) => {
    const newSequences = [...triggerSequences];
    newSequences[sequenceIndex] = [];
    setTriggerSequences(newSequences);
  };

  const handleSequenceDelete = (sequenceIndex) => {
    const newSequences = triggerSequences.filter((_, idx) => idx !== sequenceIndex);
    setTriggerSequences(newSequences.length > 0 ? newSequences : [[]]);
  };

  const handleFilterDelete = (filterKey) => {
    const newSequences = triggerSequences.map((sequence) =>
      sequence.filter((row) => row.key !== filterKey)
    );
    setTriggerSequences(newSequences);
  };

  const handleSequenceEdit = (sequenceIndex) => {
    console.log("Edit sequence:", sequenceIndex);
  };

  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={false}
      popupStyle={{
        width: "870px",
        minHeight: "558px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="create-trigger-modal">
        <h2 className="create-trigger-title">
          {editingTriggerId ? "Edit Trigger" : "Create Trigger"}
        </h2>

        {/* Trigger Name */}
        <div className="trigger-form-section">
          <label className="trigger-form-label">Trigger Name</label>
          <input
            type="text"
            className="trigger-name-input"
            placeholder="Daniel"
            value={triggerName}
            onChange={(e) => setTriggerName(e.target.value)}
          />
        </div>

        {/* Status and Auto-Trigger */}
        <div className="trigger-status-section">
          <div className="trigger-checkbox-item">
            <input
              type="checkbox"
              className="checkbox-primary"
              checked={triggerStatus}
              onChange={(e) => setTriggerStatus(e.target.checked)}
            />
            <span className="trigger-checkbox-label">Active</span>
          </div>
          <div className="trigger-checkbox-item">
            <input
              type="checkbox"
              className="checkbox-primary"
              checked={triggerAutoTrigger}
              onChange={(e) => setTriggerAutoTrigger(e.target.checked)}
            />
            <span className="trigger-checkbox-label">Auto-Trigger</span>
          </div>
        </div>

        {/* Rules Section */}
        <div className="trigger-form-section">
          <label className="trigger-form-label">Rules</label>
          <div className="trigger-rules-container">
            <SequenceList
              sequences={triggerSequences}
              vendor="hubspot"
              dropdownData={null}
              onSequenceClear={handleSequenceClear}
              onSequenceDelete={handleSequenceDelete}
              onAddSequence={handleAddSequence}
              selectedSequenceIndex={null}
              onFilterDelete={handleFilterDelete}
              onSequenceEdit={handleSequenceEdit}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="trigger-modal-buttons">
          <button className="trigger-modal-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="trigger-modal-save" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </PopupWin>
  );
};

export default CreateTriggerModal;
